document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.morro-mobile-nav__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const menu = link.closest('details');
      if (menu) menu.open = false;
    });
  });
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;


  document.querySelectorAll('[data-morro-gallery]').forEach((gallery) => {
    const thumbs = Array.from(gallery.querySelectorAll('[data-morro-gallery-thumb]'));
    const panels = Array.from(gallery.querySelectorAll('[data-morro-gallery-panel]'));

    const selectMedia = (index) => {
      thumbs.forEach((thumb, position) => {
        const active = position === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      panels.forEach((panel, position) => {
        const active = position === index;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };

    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => selectMedia(index)));
  });

  document.querySelectorAll('[data-morro-slideshow]').forEach((slideshow) => {
    if (slideshow.dataset.initialized) return;
    slideshow.dataset.initialized = 'true';
    const slides = Array.from(slideshow.querySelectorAll('[data-morro-slide]'));
    const track = slideshow.querySelector('[data-morro-slide-track]');
    const dots = Array.from(slideshow.querySelectorAll('[data-morro-slide-dot]'));
    const toggle = slideshow.querySelector('[data-morro-slide-toggle]');
    if (!slides.length || !track) return;
    let current = 0;
    let timer;
    let paused = reducedMotion;
    let hovered = false;
    let focused = false;
    let gesture = null;
    let suppressClickUntil = 0;
    const stop = () => window.clearInterval(timer);
    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slideshow.style.setProperty('--morro-slide-index', current);
      slideshow.style.setProperty('--morro-drag-x', '0px');
      slides.forEach((slide, position) => {
        const active = position === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
      dots.forEach((dot, position) => {
        const active = position === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    const start = () => {
      stop();
      if (!paused && !hovered && !focused && !gesture && !document.hidden && slides.length > 1) {
        timer = window.setInterval(() => showSlide(current + 1), 6500);
      }
    };
    const updateToggle = () => {
      if (!toggle) return;
      toggle.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
      toggle.textContent = paused ? '▶' : 'Ⅱ';
    };
    const manual = (index) => {
      paused = true;
      stop();
      updateToggle();
      showSlide(index);
    };
    slideshow.querySelector('[data-morro-slide-prev]')?.addEventListener('click', () => manual(current - 1));
    slideshow.querySelector('[data-morro-slide-next]')?.addEventListener('click', () => manual(current + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => manual(index)));
    toggle?.addEventListener('click', () => {
      paused = !paused;
      updateToggle();
      start();
    });
    slideshow.addEventListener('mouseenter', () => { hovered = true; stop(); });
    slideshow.addEventListener('mouseleave', () => { hovered = false; start(); });
    slideshow.addEventListener('focusin', () => { focused = true; stop(); });
    slideshow.addEventListener('focusout', (event) => {
      focused = slideshow.contains(event.relatedTarget);
      start();
    });
    slideshow.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      if (event.target.closest('input, textarea, select')) return;
      event.preventDefault();
      manual(current + (event.key === 'ArrowRight' ? 1 : -1));
    });
    document.addEventListener('visibilitychange', start);
    track.addEventListener('pointerdown', (event) => {
      // Links and buttons must keep their normal click target.
      if (!event.isPrimary || event.button !== 0 || event.target.closest('a, button, input, select, textarea, summary')) return;
      gesture = { id: event.pointerId, x: event.clientX, y: event.clientY, dx: 0, dragging: false };
      stop();
    });
    track.addEventListener('pointermove', (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging) {
        if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) { gesture = null; start(); return; }
        if (Math.abs(dx) < 10) return;
        gesture.dragging = true;
        track.setPointerCapture(event.pointerId);
        slideshow.classList.add('is-dragging');
      }
      gesture.dx = dx;
      slideshow.style.setProperty('--morro-drag-x', dx + 'px');
    });
    const finish = (event) => {
      if (!gesture || event.pointerId !== gesture.id) return;
      const completed = gesture;
      gesture = null;
      slideshow.classList.remove('is-dragging');
      if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
      if (completed.dragging) {
        suppressClickUntil = performance.now() + 400;
        const threshold = Math.min(70, slideshow.clientWidth * 0.15);
        manual(event.type !== 'pointercancel' && Math.abs(completed.dx) > threshold
          ? current + (completed.dx < 0 ? 1 : -1) : current);
      } else {
        showSlide(current);
        start();
      }
    };
    track.addEventListener('pointerup', finish);
    track.addEventListener('pointercancel', finish);
    track.addEventListener('pointerleave', (event) => {
      if (gesture && !gesture.dragging) finish(event);
    });
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.addEventListener('click', (event) => {
      if (performance.now() >= suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
      suppressClickUntil = 0;
    }, true);
    showSlide(0);
    updateToggle();
    start();
  });

  const revealTargets = document.querySelectorAll([
    '.morro-home--v2 > section:not(.morro-slideshow)',
    '.morro-product--v2 .morro-product__top',
    '.morro-product--v2 .morro-product__details',
    '.morro-product--v2 .morro-product__faq',
    '.morro-product--v2 .morro-cross-sell',
    '.morro-catalog__products'
  ].join(','));

  if (reducedMotion || !('IntersectionObserver' in window)) {
    revealTargets.forEach((target) => target.classList.add('morro-reveal--visible'));
  } else {
    revealTargets.forEach((target) => target.classList.add('morro-reveal'));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('morro-reveal--visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealTargets.forEach((target) => observer.observe(target));
  }
});

(() => {
  const initializeHeader = () => {
    const section = document.querySelector('.morro-header-section');
    if (!section || section.dataset.morroHeaderReady) return;
    section.dataset.morroHeaderReady = 'true';
    const measure = () => document.documentElement.style.setProperty('--morro-header-height', Math.ceil(section.getBoundingClientRect().height) + 'px');
    measure();
    if ('ResizeObserver' in window) new ResizeObserver(measure).observe(section);
    else window.addEventListener('resize', measure);
    const motion = section.querySelector('[data-morro-motion-toggle]');
    motion?.addEventListener('click', () => {
      const paused = document.documentElement.classList.toggle('morro-motion-paused');
      motion.setAttribute('aria-label', paused ? motion.dataset.playLabel : motion.dataset.pauseLabel);
      motion.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
    });
    const updateCount = (cart) => {
      if (!Number.isInteger(cart?.item_count)) return;
      document.querySelectorAll('[data-morro-cart-count]').forEach((count) => { count.textContent = cart.item_count; });
      section.querySelectorAll('[data-morro-cart-link]').forEach((link) => {
        link.setAttribute('aria-label', link.dataset.labelTemplate.replace('[count]', cart.item_count));
        link.classList.remove('is-cart-updated');
        requestAnimationFrame(() => link.classList.add('is-cart-updated'));
        window.setTimeout(() => link.classList.remove('is-cart-updated'), 650);
      });
    };
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => updateCount(event.cartData));
    }
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.ok ? response.json() : null).then(updateCount).catch(() => {});
    });
    section.querySelector('.morro-mobile-nav')?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        event.currentTarget.open = false;
        event.currentTarget.querySelector('summary').focus();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeHeader);
  else initializeHeader();
  document.addEventListener('shopify:section:load', initializeHeader);
})();
